import { render, staticRenderFns } from "./OsLinksOverview.vue?vue&type=template&id=c089d228&scoped=true"
import script from "./OsLinksOverview.vue?vue&type=script&lang=ts"
export * from "./OsLinksOverview.vue?vue&type=script&lang=ts"
import style0 from "./OsLinksOverview.vue?vue&type=style&index=0&id=c089d228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c089d228",
  null
  
)

export default component.exports